export default {"src":"/_next/static/image/public/assets/phone.9ed708f1f82a33f2b5c2041de302bf85.svg","height":31,"width":30};